import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { cn } from '../lib/utils';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './ui/breadcrumb';

// Nested trails already provide parent navigation, so identity cards should omit a back button.
export const hasNestedLinks = (items = []) => (
  items.filter((item) => item.href).length >= 1
);

const crumbItemShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  mono: PropTypes.bool,
});

const CrumbNode = ({ item, isLast }) => {
  if (item.href && !isLast) {
    return (
      <BreadcrumbLink asChild>
        <Link to={item.href}>{item.label}</Link>
      </BreadcrumbLink>
    );
  }
  if (isLast) {
    return (
      <BreadcrumbPage className={item.mono ? 'font-mono tracking-tight' : undefined}>
        {item.label}
      </BreadcrumbPage>
    );
  }
  return <span className="font-medium text-slate-500">{item.label}</span>;
};

CrumbNode.propTypes = {
  item: crumbItemShape.isRequired,
  isLast: PropTypes.bool.isRequired,
};

const PageBreadcrumb = ({ items, className }) => {
  if (!items?.length) return null;

  return (
    <Breadcrumb className={cn(className)}>
      <BreadcrumbList>
        {items.map((item, index) => (
          <Fragment key={item.href ? `${item.label}:${item.href}` : item.label}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              <CrumbNode item={item} isLast={index === items.length - 1} />
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

PageBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(crumbItemShape).isRequired,
  className: PropTypes.string,
};

export default PageBreadcrumb;
